import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_ITEMCOMPONENTTYPES_LOAD,
    ACTION_ITEMCOMPONENTTYPES_LOAD_BY_ID,

    ACTION_ITEMCOMPONENTTYPES_SAVE,

    ACTION_ITEMCOMPONENTTYPES_CREATE,

    ACTION_ITEMCOMPONENTTYPES_VALIDATE,

    IItemComponentTypeLoadAction,
    IItemComponentTypeLoadByIdAction,
    IItemComponentTypeLoadFailureAction,
    IItemComponentTypeLoadSuccessAction,

    IItemComponentTypeSaveAction,
    IItemComponentTypeSaveSuccessAction,
    IItemComponentTypeSaveFailureAction,

    IItemComponentTypeCreateAction,
    IItemComponentTypeCreateSuccessAction,
    IItemComponentTypeCreateFailureAction,

    IItemComponentTypeValidateAction,
    IItemComponentTypeValidateSuccessAction,
    IItemComponentTypeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/itemComponentType";
import { itemComponentTypesApi } from "../services/itemComponentTypes";


export const
    getItemComponentTypesEpic = (action$): Observable<IItemComponentTypeLoadSuccessAction | IItemComponentTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_ITEMCOMPONENTTYPES_LOAD)
            .mergeMap((_action: IItemComponentTypeLoadAction) => {
                return itemComponentTypesApi
                    .getItemComponentTypes()
                    .map(response =>
                        LoadSuccess(response.itemComponentTypes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getItemComponentTypeByIdEpic = (action$): Observable<IItemComponentTypeLoadSuccessAction | IItemComponentTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_ITEMCOMPONENTTYPES_LOAD_BY_ID)
            .mergeMap((action: IItemComponentTypeLoadByIdAction) => {
                return itemComponentTypesApi
                    .getItemComponentTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.itemComponentType, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setItemComponentTypeEpic = (action$): Observable<IItemComponentTypeSaveSuccessAction | IItemComponentTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_ITEMCOMPONENTTYPES_SAVE)
            .mergeMap((action: IItemComponentTypeSaveAction) => {
                return itemComponentTypesApi
                    .setItemComponentType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.itemComponentType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createItemComponentTypeEpic = (action$): Observable<IItemComponentTypeCreateSuccessAction | IItemComponentTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_ITEMCOMPONENTTYPES_CREATE)
            .mergeMap((_action: IItemComponentTypeCreateAction) => {
                return itemComponentTypesApi
                    .createItemComponentType()
                    .map(response =>
                        CreateSuccess(
                            response.itemComponentType,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateItemComponentTypeEpic = (action$): Observable<IItemComponentTypeValidateSuccessAction | IItemComponentTypeValidateFailureAction> => {
        return action$
            .ofType(ACTION_ITEMCOMPONENTTYPES_VALIDATE)
            .mergeMap((action: IItemComponentTypeValidateAction) => {
                return itemComponentTypesApi
                    .validateItemComponentType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.itemComponentType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



